import { useCallback, useContext } from 'react';

import { CockpitUsersContext } from 'context/CockpitUsersContext';

// useUserName turns a user id into the person's name, using the cockpit users list.
// It falls back to the id when the user is not found or the list is not available.
export function useUserName() {
  const users = useContext(CockpitUsersContext);
  return useCallback((userId) => {
    if (!userId) return '';
    try {
      return users?.getUserName?.(userId) || userId;
    } catch {
      return userId;
    }
  }, [users]);
}

export default useUserName;
